/**
 * Controla a reprodução automática de vídeos no hover dos cards de produto
 */
class CardProductVideo {
  constructor() {
    this.videos = document.querySelectorAll('.card-product-secondary-video');
    this.init();
  }

  init() {
    if (this.videos.length === 0) return;

    this.videos.forEach((video) => {
      const cardWrapper = video.closest('.card-wrapper');
      if (!cardWrapper) return;

      // Pausa o vídeo inicialmente
      video.pause();
      video.currentTime = 0;

      // Evento de hover - mouseenter
      cardWrapper.addEventListener('mouseenter', () => {
        if (video.readyState >= 2) {
          // Se o vídeo já carregou metadados, toca imediatamente
          video.play().catch((error) => {
            // Ignora erros de autoplay (alguns navegadores bloqueiam)
            console.debug('Video autoplay blocked:', error);
          });
        } else {
          // Se ainda não carregou, espera o evento loadedmetadata
          video.addEventListener(
            'loadedmetadata',
            () => {
              video.play().catch((error) => {
                console.debug('Video autoplay blocked:', error);
              });
            },
            { once: true }
          );
        }
      });

      // Evento de saída do hover - mouseleave
      cardWrapper.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0; // Volta ao início
      });

      // Garante que o vídeo está pausado quando a página carrega
      video.addEventListener('loadedmetadata', () => {
        video.pause();
        video.currentTime = 0;
      });
    });
  }
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CardProductVideo();
  });
} else {
  new CardProductVideo();
}

// Re-inicializa quando novos cards são carregados dinamicamente (ex: AJAX)
document.addEventListener('shopify:section:load', () => {
  new CardProductVideo();
});

